import { Routes } from '@angular/router';

import { routeNames } from '../../shared/route-names';
import { LoggedInGuard } from '../shared/guards/loggedin.guard';
import {AdminGuard} from "../shared/guards/admin.guard";
import {AdministrationGuard} from "../shared/guards/administration.guard";
import { OauthCallbackComponent } from '../auth/components/oauth-callback/oauth-callback.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../home/home.module').then((m) => m.HomeModule),
    data: { title: 'general.navigation.home' },
    canActivate: [LoggedInGuard],
  },
  {
    path: 'oauth2/token',
    component: OauthCallbackComponent,
  },
  {
    path: routeNames.administration,
    data: { title: "general.navigation.administration" },
    canActivate: [AdministrationGuard],
    canMatch: [AdministrationGuard],
    loadChildren: () =>
        import("../administration/administration.module").then(
            (m) => m.AdministrationModule,
        ),
  },
  {
    path: routeNames.auth,
    loadChildren: () => import("../auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: routeNames.howItWorks,
    data: { title: "general.navigation.how-it-works" },
    loadChildren: () => import("../how-it-works/how-it-works.module").then((m) => m.HowItWorksModule),
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
